import styled from "styled-components";
import { device } from "./Device";

const MenuHeader = styled.header`
  z-index: 2;
  max-width: 150rem;
  height: 3.5rem;
  margin: 0 auto;
  padding: 5.75rem 4.875rem;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  background-color: transparent;
`;
const HeaderBorderTopLef = styled.div`
  position: absolute;
  top: 3.75rem;
  left: 4.875rem;
  width: calc((100% - 15.875rem) / 2);
  height: 1px;
  ${"" /* background-color: #303030; */}
  background-color: rgb(223, 223, 223);
`;
const HeaderBorderTopRight = styled.div`
  position: absolute;
  top: 3.75rem;
  right: 4.875rem;
  width: calc((100% - 15.875rem) / 2);
  height: 1px;
  ${"" /* background-color: #303030; */}
  background-color: rgb(223, 223, 223);
`;
const HeaderBorderBottomLeft = styled.div`
  position: absolute;
  bottom: 3.75rem;
  left: 4.875rem;
  width: calc((100% - 15.875rem) / 2);
  height: 1px;
  ${"" /* background-color: #303030; */}
  background-color: rgb(223, 223, 223);
`;
const HeaderBorderBottomRight = styled.div`
  position: absolute;
  right: 4.875rem;
  bottom: 3.75rem;
  width: calc((100% - 15.875rem) / 2);
  height: 1px;
  ${"" /* background-color: #303030; */}
  background-color: rgb(223, 223, 223);
`;

const HeaderLogo = styled.img`
  position: relative;
  width: 10rem;
  height: 7.125rem;
  top: -42px;
  right: 0;
  bottom: 0;
  left: -65px;
  margin: auto;
  display: block;
  @media ${device.tablet} {
    display: none;
  }
`;

const HeaderList = styled.ul`
  display: block;
  position: absolute;
  right: 4.875rem;
  margin-right: 0.75rem;
  padding-left: 0.625rem;

  @media ${device.tablet} {
    margin: 0 auto;
    padding: 0;
    position: unset;
  }
`;
const HeaderListItem = styled.li`
  display: inline-block;
  margin-right: 4.375rem;
  border: none;

  @media ${device.mobileS} {
    margin-right: 1.5em;
  }
`;
const MenuItems = styled.a`
    width: 100%;
    position: relative;
    display: block;
    height: auto;
    padding: .9375rem 0;
    background-color: transparent;
    text-align: left;
}`;

const MenuItemsTitle = styled.p`
  display: inline-block;
  vertical-align: middle;
  font-family: "Allerta Stencil";
  font-size: 1.3rem;
  ${"" /* color: #303030; */}
  color: rgb(223, 223, 223);
  position: relative;
  text-align: center;
`;
const HeaderTitle = styled.div`
  display: block;
  font-size: 1.3rem;
  letter-spacing: 0.25em;
  font-family: "Allerta Stencil";
  ${"" /* color: #303030; */}
  color: rgb(223, 223, 223);

  @media ${device.tablet} {
    display: none;
  }
`;

export {
  MenuHeader,
  MenuItems,
  MenuItemsTitle,
  HeaderBorderTopLef,
  HeaderBorderTopRight,
  HeaderBorderBottomLeft,
  HeaderBorderBottomRight,
  HeaderLogo,
  HeaderTitle,
  HeaderList,
  HeaderListItem,
};
